/// <reference path='../../docs-and-forms.module.ts' />
/// <reference path='../../../../../../typings/index.d.ts' />
///<reference path="../../docs-and-forms.models.ts"/>
///<reference path="../../docs-and-forms-render.service.ts"/>

module Meevo.Plugins.DocsAndForms {

    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    class DocsAndFormsUploadedHtmlPreviewComponent implements ng.IComponentController {


        static $inject = [
            'meevo.plugins.docsAndForms.DocsAndFormsRenderService',
            'meevo.plugins.docsAndForms.DocsAndFormsApiService',
            '$sce',
            '$scope'
        ];

        public docsAndFormsModel: IDocsAndFormsModel;
        public onPreviewLoad: () => void;

        public previewHtml: string;
        public loading: boolean;

        private assignedUDFs;

        constructor(private docsAndFormsRenderService: DocsAndFormsRenderService,
                    private docsAndFormsApiService: DocsAndFormsApiService,
                    private $sce: ng.ISCEService,
                    private $scope: ng.IScope) {

        }

        $onInit() {
            if (!this.docsAndFormsModel) {
                return;
            }

            this.$scope.$watch(() => this.docsAndFormsModel.templateHTML, () => {
                this.docsAndFormsApiService
                    .getAssignedUDFs(this.docsAndFormsModel.id, this.docsAndFormsModel.tabTypeEnum)
                    .then((data: IUserDefinedControl[]) => {
                        this.assignedUDFs = data;
                        this.generatePreview();
                    });
            });
        }

        onIframeLoad() {
            if (this.onPreviewLoad) {
                this.onPreviewLoad();
            }
        }

        private generatePreview() {
            let html;
            if (this.docsAndFormsModel.formCreationTypeEnum === DocsAndFormsCreationTypeEnum.WYSIWYG) {
                html = this.docsAndFormsRenderService.populateDefaultValues(this.docsAndFormsModel.templateHTML, this.assignedUDFs);
            } else {
                html = this.docsAndFormsRenderService.generatePreviewHtml(this.docsAndFormsModel);
                html = this.docsAndFormsRenderService.populateDefaultValues(html, this.assignedUDFs);
            }
            this.previewHtml = this.$sce.trustAsHtml(html);
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .component('docsAndFormsUploadedHtmlPreviewComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/docsAndForms/components/uploaded-html-preview/docs-and-forms-uploaded-html-preview.component.html',
            controller: DocsAndFormsUploadedHtmlPreviewComponent,
            controllerAs: '$ctrl',
            bindings: {
                docsAndFormsModel: '=',
                loading: '=?',
                onPreviewLoad: '&?'
            }
        });

}
